import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Hardcoded palette — this component renders OUTSIDE the ThemeProvider
      // because React's tree may be partially torn down when this fires, so
      // theme tokens aren't safe to reference. The values mirror the Dark+Gold
      // theme so error states stay on-brand.
      return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(160deg, #0A0A0B 0%, #14130F 100%)', color: '#F5F2E9', fontFamily: 'Space Grotesk, system-ui, sans-serif', padding: 24 }}>
          <div style={{ textAlign: 'center', maxWidth: 440, padding: 32, background: 'rgba(20,19,15,0.6)', border: '1px solid rgba(201,162,39,0.22)', borderRadius: 16 }}>
            <div style={{ marginBottom: 20, display: 'flex', justifyContent: 'center' }}>
              <div style={{ width: 56, height: 56, borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(229,72,77,0.12)', border: '1px solid rgba(229,72,77,0.30)' }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#E5484D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              </div>
            </div>
            <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 10, letterSpacing: '-0.01em' }}>Something went wrong.</h1>
            <p style={{ color: '#A8A294', fontSize: 14, marginBottom: 28, lineHeight: 1.6 }}>
              The workspace caught an unexpected error. Refreshing usually resolves it.
            </p>
            <button onClick={() => window.location.reload()}
              style={{ background: 'linear-gradient(135deg, #C9A227, #E6C04A)', color: '#0A0A0B', border: 'none', padding: '11px 32px', borderRadius: 12, fontSize: 14, fontWeight: 600, cursor: 'pointer', letterSpacing: '0.01em' }}>
              Refresh
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
